/**
 * Use this component instead of a normal page when you run into an unhandled error.
 * Sort of like a 500 page.
 *
 * @param errorMessage
 * @param retryText
 * @param activityText
 */
export default function UnhandledError({
  errorMessage,
  retryText,
  activityText
}: {
  errorMessage?: string;
  retryText?: string;
  activityText?: string;
}) {
  return (
    <div className="flex flex-col h-screen justify-center items-center box-border p-5">
      <h1 className="text-xl font-bold mb-2">
        Sorry, that wasn&rsquo;t supposed to happen!&nbsp;
      </h1>
      <h2 className="text-lg font-medium text-content-500 mb-8">
        {activityText}
      </h2>
      <p>
        It may be a temporary problem, or it may be an issue with Boom, but our
        team is already on it.&nbsp;
      </p>
      <p className="text-center">
        {retryText}, and if you see this page again, feel free to reach out to
        us. <br />
        Here's what we know about the error:&nbsp;
      </p>
      <p className="max-w-[440px] my-8 font-mono p-2 bg-danger-50 border-danger-200 border-2 rounded-md shadow-sm">
        {errorMessage}{" "}
      </p>

      <p className="text-xs text-content-400">
        Your data is encrypted and stored with bank-level security.
      </p>
    </div>
  );
}
